var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 252,
    viewBox: "0 0 290 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.965 7.66307e-05C169.198 -0.0525992 188.14 27.0642 211.705 42.566C236.776 59.058 270.622 66.3667 283.195 93.5615C296.157 121.594 288.647 155.102 276.953 183.683C265.84 210.844 247.156 236.807 219.983 248.059C194.918 258.438 167.501 245.675 140.965 239.993C120.425 235.595 102.812 226.497 83.2797 218.786C55.0859 207.657 10.6199 213.641 1.31614 184.869C-7.9957 156.071 34.6975 136.725 47.9415 109.501C58.4615 87.8766 54.8363 61.1694 70.4164 42.8296C88.657 21.3579 112.741 0.0527351 140.965 7.66307e-05Z",
    fill: "#88CCDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices01);
export default __webpack_public_path__ + "static/media/services-01.d2227cb8b357a6e6399b1d54a87feb4d.svg";
export { ForwardRef as ReactComponent };